/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { createAction } from '../../modules/app/createAction';
import {
    WIZARD_MULTI_SEARCH_ATTACH_FILE,
    WIZARD_MULTI_SEARCH_ATTACH_FILE_FAILED,
    WIZARD_MULTI_SEARCH_ATTACH_FILE_SUCCESSFUL,
    WIZARD_MULTI_SEARCH_GET_SUBSCRIBER_LIST,
    WIZARD_MULTI_SEARCH_GET_SUBSCRIBER_LIST_FAILED,
    WIZARD_MULTI_SEARCH_GET_SUBSCRIBER_LIST_SUCCESSFUL,
    WIZARD_MULTI_SEARCH_HANDLE_NEXT,
    WIZARD_MULTI_SEARCH_SET_PARAMS,
    WIZARD_MULTI_SEARCH_SET_STEP_VALID,
    WIZARD_MULTI_SEARCH_START_VALIDATE,
} from './constant';
import {
    IWizardMultiSearchAttachFilePayload,
    IWizardMultiSearchAttachFileSuccessfulPayload,
    IWizardMultiSearchGetSubscriberListAction,
    IWizardMultiSearchGetSubscriberListFailureAction,
    IWizardMultiSearchGetSubscriberListFailurePayload,
    IWizardMultiSearchGetSubscriberListPayload,
    IWizardMultiSearchGetSubscriberListSuccessAction,
    IWizardMultiSearchGetSubscriberListSuccessfulPayload,
    IWizardMultiSearchSetStepValidPayload,
    TWizardMultiSearchAttachFileAction,
    TWizardMultiSearchAttachFileFailureAction,
    TWizardMultiSearchAttachFileSuccessAction,
    TWizardMultiSearchHandleNextAction,
    TWizardMultiSearchSetParamsAction,
    TWizardMultiSearchSetParamsPayload,
    TWizardMultiSearchSetStepValidAction,
    TWizardMultiSearchStartValidateAction,
} from './types';

/*
* -------------------------------------------
*         Common Wizard Actions
* -------------------------------------------
*/

export const wizardMultiSearchHandleNextAction = (): TWizardMultiSearchHandleNextAction =>
    createAction(WIZARD_MULTI_SEARCH_HANDLE_NEXT);

export const wizardMultiSearchSetParamsAction = (payload: TWizardMultiSearchSetParamsPayload)
    : TWizardMultiSearchSetParamsAction =>
    createAction(WIZARD_MULTI_SEARCH_SET_PARAMS, payload);

export const wizardMultiSearchStartValidateAction = (): TWizardMultiSearchStartValidateAction =>
    createAction(WIZARD_MULTI_SEARCH_START_VALIDATE);

export const wizardMultiSearchSetStepValidAction = (payload: IWizardMultiSearchSetStepValidPayload):
    TWizardMultiSearchSetStepValidAction =>
    createAction(WIZARD_MULTI_SEARCH_SET_STEP_VALID, payload);

/*
* -------------------------------------------
*          ATTACH FILE
* -------------------------------------------
*/

export const wizardMultiSearchAttachFile = (payload: IWizardMultiSearchAttachFilePayload):
    TWizardMultiSearchAttachFileAction => createAction(WIZARD_MULTI_SEARCH_ATTACH_FILE, payload);

export const wizardMultiSearchAttachFileSuccessful =
    (payload: IWizardMultiSearchAttachFileSuccessfulPayload):
        TWizardMultiSearchAttachFileSuccessAction =>
        createAction(WIZARD_MULTI_SEARCH_ATTACH_FILE_SUCCESSFUL, payload);

export const wizardMultiSearchAttachFileFailed =
    (payload: string): TWizardMultiSearchAttachFileFailureAction =>
        createAction(WIZARD_MULTI_SEARCH_ATTACH_FILE_FAILED, payload);

/*
* -------------------------------------------
*          Subscriber List
* -------------------------------------------
*/

export const wizardMultiSearchGetSubscriberListAction = (payload: IWizardMultiSearchGetSubscriberListPayload):
    IWizardMultiSearchGetSubscriberListAction => createAction(WIZARD_MULTI_SEARCH_GET_SUBSCRIBER_LIST, payload);

export const wizardMultiSearchGetSubscriberListSuccessAction =
    (payload: IWizardMultiSearchGetSubscriberListSuccessfulPayload):
        IWizardMultiSearchGetSubscriberListSuccessAction =>
        createAction(WIZARD_MULTI_SEARCH_GET_SUBSCRIBER_LIST_SUCCESSFUL, payload);

export const wizardMultiSearchGetSubscriberListFailureAction =
    (payload: IWizardMultiSearchGetSubscriberListFailurePayload):
        IWizardMultiSearchGetSubscriberListFailureAction =>
        createAction(WIZARD_MULTI_SEARCH_GET_SUBSCRIBER_LIST_FAILED, payload);
